module.exports = __webpack_public_path__ + "static/wheel-52962f3917f7ad33bda559efbc7e7c59.png";